import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { StorageService } from '../../shared/storage.service';
import { FooterService } from '../../components/footer/footer.service';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.css']
})
export class PackageComponent implements OnInit {
  // categoryId: string = '';
  categoryTitle: string = '';
  searchTerm: string = '';
  responseData: any = [];
  allPackagesDataList: any = [];
  noData = true;
  headerTitle: string = '';
  // endOfList = false;
  pageNumber = 1;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public userLayoutService: UserLayoutService,
    public storageService: StorageService,
    private footerService: FooterService,
  ) { }

  ngOnInit(): void {
    this.footerService.showFooter();

    this.route.queryParams.subscribe(params => {
      // this.categoryId = params['categoryId'];
      this.categoryTitle = params['category'];
      this.searchTerm = params['place'];
      if (this.searchTerm) {
        this.headerTitle = this.searchTerm;
        this.getPackagesDetailsById();
      } else if (this.categoryTitle) {
        this.headerTitle = this.categoryTitle;
        this.getPackagesDetailsByDayAndNight();
      } else {
        this.router.navigate(['home']);
      }
    });
  }

  getPackagesDetailsByDayAndNight() {
    const str = this.categoryTitle;
    // const matches = str.match(/(\d+)\s*Days\s*\/\s*(\d+)\s*Nights/);

    // if (matches) {
    let getData = {
      searchkey: this.categoryTitle,
    }
    this.userLayoutService.getPackagesDetailsByDaysAndNights(getData).subscribe((Response: any) => {

      if (Response.code == 1) {
        this.allPackagesDataList = [];
        this.noData = false;
        this.allPackagesDataList = Response.data
        .map((pkg: any) => {
          const match = pkg.numberOfDaysAndNight.match(/(\d+)\s*Days\s*(\d+)\s*Nights/i);
          return {
            ...pkg,
            totalDay: match ? parseInt(match[1], 10) : null,
            totalNight: match ? parseInt(match[2], 10) : null,
          };
        });
        // console.log("packages data", this.allPackagesDataList);
      }
      else {
        this.noData = true;
      }
    }, (error) => {
      // console.log(error.error.Message);
      this.noData = true;
    });
    // } else {
    //   // console.log("Invalid format");
    // }
  }


  // onScroll() {
  //   console.log("scrolled",this.endOfList);
  //   if (this.endOfList === false) {
  //     console.log("scroll inside");
  //     this.pageNumber += 1;
  //     this.getPackagesDetailsById();
  //   } else {
  //     console.log("out")
  //     return;
  //   }
  // }

  getPackagesDetailsById() {
    let param = {
      searchTerm: this.searchTerm,
    }

    // Send the inquiry request
    this.userLayoutService.getPackagesDetailsBySearchTerm(param).subscribe(
      (Response: any) => {

        if (Response.code === 1) {
          this.allPackagesDataList = [];
          this.noData = false;
          // this.allPackagesDataList = Response.data;
          this.allPackagesDataList = Response.data
            .map((pkg: any) => {
              const match = pkg.numberOfDaysAndNight.match(/(\d+)\s*Days\s*(\d+)\s*Nights/i);
              return {
                ...pkg,
                totalDay: match ? parseInt(match[1], 10) : null,
                totalNight: match ? parseInt(match[2], 10) : null,
              };
            });
        } else {
          this.router.navigate(['home']);
          this.searchTerm = null;
          this.commonService.notifier.notify('error', Response.message);
        }
      },
      (error) => {
        this.router.navigate(['home']);
        this.searchTerm = null;
        this.commonService.notifier.notify('error', error);
      }
    );
  }

  packageDetails(packageId: any) {
    this.router.navigate(['packages-details'], {
      queryParams: { PackageId: packageId }
    });
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/safenet_logo_new.png';
  }
}
